import { Stack, Typography, Tooltip, Box, Skeleton } from "@mui/material";
import { InfoRounded } from "@mui/icons-material";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { CopyTextField } from "../../../../../../../../shell/components/CopyTextField";
import { useGetContentItemQuery, useGetContentModelQuery } from "../../../../../../../../shell/services/instance";
export const CodeSample = () => {
  const {
    t
  } = useTranslation();
  const {
    modelZUID,
    itemZUID
  } = useParams<{
    itemZUID: string;
    modelZUID: string;
  }>();
  const {
    data: model,
    isLoading: isLoadingModel
  } = useGetContentModelQuery(modelZUID);
  const {
    data: item,
    isLoading: isLoadingItem
  } = useGetContentItemQuery(itemZUID);
  return <Stack gap={2} my={2} height="calc(100% - 80px)" sx={{
    overflowY: "auto"
  }} data-sentry-element="Stack" data-sentry-component="CodeSample" data-sentry-source-file="CodeSample.tsx">
      <Box data-sentry-element="Box" data-sentry-source-file="CodeSample.tsx">
        <Stack direction="row" alignItems="center" gap={1} pb={0.5} data-sentry-element="Stack" data-sentry-source-file="CodeSample.tsx">
          <Typography variant="body2" sx={{
          fontWeight: 600
        }} data-sentry-element="Typography" data-sentry-source-file="CodeSample.tsx">
            {t("content.codeSampleBlockSelector")}
          </Typography>
          <Tooltip title={t("content.codeSampleBlockSelectorTip")} data-sentry-element="Tooltip" data-sentry-source-file="CodeSample.tsx">
            <InfoRounded color="action" sx={{
            width: 12,
            height: 12
          }} data-sentry-element="InfoRounded" data-sentry-source-file="CodeSample.tsx" />
          </Tooltip>
        </Stack>
        <CopyTextField value="{{ block({this.block_selector_field}) }}" data-sentry-element="CopyTextField" data-sentry-source-file="CodeSample.tsx" />
      </Box>

      <Box data-sentry-element="Box" data-sentry-source-file="CodeSample.tsx">
        <Stack direction="row" alignItems="center" gap={1} pb={0.5} data-sentry-element="Stack" data-sentry-source-file="CodeSample.tsx">
          <Typography variant="body2" sx={{
          fontWeight: 600
        }} data-sentry-element="Typography" data-sentry-source-file="CodeSample.tsx">
            {t("content.codeSampleBaseTemplate")}
          </Typography>
          <Tooltip title={t("content.codeSampleBaseTemplateTip")} data-sentry-element="Tooltip" data-sentry-source-file="CodeSample.tsx">
            <InfoRounded color="action" sx={{
            width: 12,
            height: 12
          }} data-sentry-element="InfoRounded" data-sentry-source-file="CodeSample.tsx" />
          </Tooltip>
        </Stack>
        {isLoadingModel ? <Skeleton variant="rounded" width="100%" height={36} /> : <CopyTextField value={`{{ block('/-/block/${model?.name}.html') }}`} />}
      </Box>

      <Box data-sentry-element="Box" data-sentry-source-file="CodeSample.tsx">
        <Stack direction="row" alignItems="center" gap={1} pb={0.5} data-sentry-element="Stack" data-sentry-source-file="CodeSample.tsx">
          <Typography variant="body2" sx={{
          fontWeight: 600
        }} data-sentry-element="Typography" data-sentry-source-file="CodeSample.tsx">
            {t("content.codeSampleBaseTemplateVersion")}
          </Typography>
          <Tooltip title={t("content.codeSampleBaseTemplateVersionTip")} data-sentry-element="Tooltip" data-sentry-source-file="CodeSample.tsx">
            <InfoRounded color="action" sx={{
            width: 12,
            height: 12
          }} data-sentry-element="InfoRounded" data-sentry-source-file="CodeSample.tsx" />
          </Tooltip>
        </Stack>
        {isLoadingModel || isLoadingItem ? <Skeleton variant="rounded" width="100%" height={36} /> : <CopyTextField value={`{{ block('/-/block/${model?.name}.html?version=${item?.web?.version}') }}`} />}
      </Box>

      <Box data-sentry-element="Box" data-sentry-source-file="CodeSample.tsx">
        <Stack direction="row" alignItems="center" gap={1} pb={0.5} data-sentry-element="Stack" data-sentry-source-file="CodeSample.tsx">
          <Typography variant="body2" sx={{
          fontWeight: 600
        }} data-sentry-element="Typography" data-sentry-source-file="CodeSample.tsx">
            {t("content.codeSampleSpecificVariant")}
          </Typography>
          <Tooltip title={t("content.codeSampleSpecificVariantTip")} data-sentry-element="Tooltip" data-sentry-source-file="CodeSample.tsx">
            <InfoRounded color="action" sx={{
            width: 12,
            height: 12
          }} data-sentry-element="InfoRounded" data-sentry-source-file="CodeSample.tsx" />
          </Tooltip>
        </Stack>
        {isLoadingModel ? <Skeleton variant="rounded" width="100%" height={36} /> : <CopyTextField value={`{{ block('/-/block/${model?.name}.html?variant=${itemZUID}') }}`} />}
      </Box>
    </Stack>;
};